export const navItems = [
  { id: "home", label: "Home", icon: "home" },
  { id: "discovery", label: "Discovery", icon: "compass" },
  { id: "queue", label: "Queue", icon: "queue" },
  { id: "library", label: "Library", icon: "library" },
  { id: "about", label: "About", icon: "about" },
  { id: "settings", label: "Settings", icon: "settings" },
];

export const heroAlbum = {
  title: "Modern Galaxy: Infinite Resonance",
  subtitle:
    "A cinematic synth journey through nebula textures, cosmic bass, and future-pop atmospheres.",
  listeners: "4.3M monthly listeners",
  duration: "58 min",
  image:
    "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1200&q=80",
};

export const recommendedCards = [
  {
    id: 1,
    title: "Nebula Pulse",
    artist: "Luna Arc",
    image:
      "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 2,
    title: "Stellar Motion",
    artist: "Orion V",
    image:
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 3,
    title: "Event Horizon",
    artist: "Nova Bloom",
    image:
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 4,
    title: "Orbital Echo",
    artist: "Astra N",
    image:
      "https://images.unsplash.com/photo-1461784121038-f088ca1e7714?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 5,
    title: "Dark Matter Groove",
    artist: "Cryo Pulse",
    image:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 6,
    title: "Celestial Drift",
    artist: "Vega Drift",
    image:
      "https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=900&q=80",
  },
];

export const relatedTracks = [
  { id: 1, title: "Cosmic Tides", artist: "Hyperlane", plays: "19.8M", duration: "3:34" },
  { id: 2, title: "Moonlit Current", artist: "Vega Drift", plays: "12.2M", duration: "4:08" },
  { id: 3, title: "Neon Satellites", artist: "Zen Radius", plays: "9.7M", duration: "2:58" },
  { id: 4, title: "Dark Matter Groove", artist: "Cryo Pulse", plays: "7.9M", duration: "3:48" },
  { id: 5, title: "Pulse of Andromeda", artist: "Nova Bloom", plays: "6.1M", duration: "3:26" },
];

export const genres = [
  { name: "Cosmic Pop", tracks: "245 tracks" },
  { name: "Future Bass", tracks: "193 tracks" },
  { name: "Synthwave", tracks: "174 tracks" },
  { name: "Ambient Space", tracks: "321 tracks" },
];

export const newReleases = [
  { title: "Solar Halo", meta: "Orion V • 2026" },
  { title: "Gravity Memoirs", meta: "Astra N • 2026" },
  { title: "Neptune Blue", meta: "Luna Arc • 2026" },
  { title: "Photon Nights", meta: "Cryo Pulse • 2026" },
];

export const playlists = [
  { id: 1, title: "Night Drive Galaxy", songs: 42, cover: "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?auto=format&fit=crop&w=900&q=80" },
  { id: 2, title: "Deep Space Coding", songs: 63, cover: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=900&q=80" },
  { id: 3, title: "Moonlight Focus", songs: 35, cover: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=900&q=80" },
  { id: 4, title: "Vocal Nebula", songs: 29, cover: "https://images.unsplash.com/photo-1496293455970-f8581aae0e3b?auto=format&fit=crop&w=900&q=80" },
];

export const queueTracks = [
  { id: 1, title: "Infinite Resonance", artist: "Nova Bloom", eta: "Now" },
  { id: 2, title: "Neon Satellites", artist: "Zen Radius", eta: "In 3:34" },
  { id: 3, title: "Moonlit Current", artist: "Vega Drift", eta: "In 7:42" },
  { id: 4, title: "Stellar Motion", artist: "Orion V", eta: "In 11:50" },
];
